module.exports = __webpack_public_path__ + "static/media/soc_linkedin.f4bb7a4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/soc_linkedin.svg
// module id = 387
// module chunks = 0